(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["store-banner"]) return;
  try {
    
  (() => {
    const bannerSelector = '[data-store-banner]';
    const storagePrefix = 'tema29StoreBannerDismissed:';

    const readDismissedState = (bannerId) => {
      try {
        return window.sessionStorage.getItem(`${storagePrefix}${bannerId}`) === 'true';
      } catch (error) {
        return false;
      }
    };

    const persistDismissedState = (bannerId) => {
      try {
        window.sessionStorage.setItem(`${storagePrefix}${bannerId}`, 'true');
      } catch (error) {
        return;
      }
    };

    const initStoreBanner = (banner) => {
      if (!banner || banner.dataset.storeBannerInitialized === 'true') return;

      const bannerId = banner.dataset.storeBannerId;
      const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);

      banner.dataset.storeBannerInitialized = 'true';

      if (!isDesignMode && bannerId && readDismissedState(bannerId)) {
        banner.hidden = true;
        banner.classList.remove('store-banner--pending');
        return;
      }

      banner.classList.remove('store-banner--pending');

      banner.querySelector('[data-store-banner-close]')?.addEventListener('click', () => {
        if (!isDesignMode && bannerId) persistDismissedState(bannerId);
        banner.hidden = true;
      });
    };

    const initStoreBanners = (root) => {
      if (root.matches?.(bannerSelector)) initStoreBanner(root);
      root.querySelectorAll?.(bannerSelector).forEach(initStoreBanner);
    };

    initStoreBanners(document);

    document.addEventListener('shopify:section:load', (event) => {
      initStoreBanners(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
